import { createElement } from 'react';
import { parseApiResponse } from '../config/apiBase';

/**
 * 3.0 offline.js fnCheckSmsCallAgree 문구 조립.
 * @param {'request'|'invite'} purpose
 */
export function buildSmsCallAgreeConfirmText(smsAgree, callAgree, purpose) {
  let msgVal1 = '';
  if (smsAgree !== 'Y' && callAgree === 'Y') {
    msgVal1 = '문자(SMS)';
  } else if (smsAgree === 'Y' && callAgree !== 'Y') {
    msgVal1 = '전화';
  } else {
    msgVal1 = '문자(SMS) 및 전화';
  }
  const msgVal2 = purpose === 'invite' ? '소개가' : '신청이';
  return `패널님께서는 현재 ${msgVal1} 수신거부 상태입니다.\n${msgVal1} 수신에 동의하셔야 좌담회 ${msgVal2} 가능합니다.\n수신에 동의하십니까?`;
}

/**
 * 3.0 offline.js fnCheckSmsCallAgree — 로그인 패널만 수신(Y) 확인·일괄 동의 후 true.
 * 비로그인은 true. 조회 실패·동의 거부·갱신 실패는 false.
 *
 * @param {object} p
 * @param {boolean} p.isLoggedIn
 * @param {(url: string, init?: RequestInit) => Promise<Response>} p.apiFetch
 * @param {(opts: object) => void} p.openSystemPopup — {@link useSystemPopup}().open
 * @param {'request'|'invite'} p.purpose
 */
export async function ensureSmsCallAgreeBeforeOfflineAction({ isLoggedIn, apiFetch, openSystemPopup, purpose }) {
  if (!isLoggedIn) {
    return true;
  }
  let data;
  try {
    const res = await apiFetch('/api/survey-offline/apply/member-receive-status', {
      method: 'POST',
      body: '{}',
    });
    data = await parseApiResponse(res);
  } catch {
    data = null;
  }
  if (!data || data.result !== 'success' || !data.myInfo) {
    openSystemPopup({
      type: 'alert',
      content: createElement(
        'p',
        { className: 'strong-text', style: { whiteSpace: 'pre-line' } },
        '신청에 필요한 패널 정보 조회에 실패하였습니다.\n다시 로그인 해주세요.'
      ),
    });
    return false;
  }
  const { smsAgree, callAgree } = data.myInfo;
  if (smsAgree === 'Y' && callAgree === 'Y') {
    return true;
  }
  const msg = buildSmsCallAgreeConfirmText(smsAgree, callAgree, purpose);
  return await new Promise((resolve) => {
    openSystemPopup({
      type: 'confirm',
      content: createElement('p', { className: 'strong-text', style: { whiteSpace: 'pre-line' } }, msg),
      confirmText: '확인',
      cancelText: '취소',
      onCancel: () => resolve(false),
      onConfirm: () => {
        (async () => {
          try {
            const ur = await apiFetch('/api/survey-offline/apply/member-receive-update', {
              method: 'POST',
              body: JSON.stringify({ smsAgree: 'Y', callAgree: 'Y' }),
            });
            const uj = await parseApiResponse(ur);
            if (uj?.result === 'success') {
              resolve(true);
              return;
            }
          } catch {
          }
          openSystemPopup({
            type: 'alert',
            content: createElement(
              'p',
              { className: 'strong-text', style: { whiteSpace: 'pre-line' } },
              '수신동의 변경에 실패하였습니다.\n잠시 후 다시 시도해 주세요.'
            ),
            onConfirm: () => resolve(false),
          });
        })();
      },
    });
  });
}
